import { Trash2, Eye, EyeOff, Star } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

var API = "/api";

function formatDate(dateStr) {
  if (!dateStr) return "N/A";
  var d = new Date(dateStr);
  return d.toLocaleDateString() + " " + d.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
}

export default function ReviewsTab({ reviews, onRefresh }) {
  function handleToggleVisibility(reviewId, currentVisibility) {
    axios.put(API + "/reviews/" + reviewId + "?is_visible=" + !currentVisibility)
      .then(function() { toast.success("Review visibility updated"); onRefresh(); })
      .catch(function() { toast.error("Failed to update"); });
  }

  function handleDelete(reviewId) {
    if (window.confirm("Delete this review permanently?")) {
      axios.delete(API + "/reviews/" + reviewId)
        .then(function() { toast.success("Review deleted"); onRefresh(); })
        .catch(function() { toast.error("Failed to delete"); });
    }
  }

  return (
    <div className="bg-[#121212] border border-white/5 rounded-sm overflow-hidden">
      <div className="p-4 border-b border-white/10">
        <h3 className="font-heading font-bold text-white">Customer Reviews</h3>
        <p className="text-[#71717a] text-sm">Only verified purchasers can leave reviews. You can hide or delete reviews as needed.</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-white/10">
              <th className="text-left p-4 font-mono text-xs text-[#A1A1AA] uppercase">Product</th>
              <th className="text-left p-4 font-mono text-xs text-[#A1A1AA] uppercase">Customer</th>
              <th className="text-left p-4 font-mono text-xs text-[#A1A1AA] uppercase">Rating</th>
              <th className="text-left p-4 font-mono text-xs text-[#A1A1AA] uppercase">Review</th>
              <th className="text-left p-4 font-mono text-xs text-[#A1A1AA] uppercase">Visible</th>
              <th className="text-right p-4 font-mono text-xs text-[#A1A1AA] uppercase">Actions</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map(function(review) {
              return (
                <tr key={review.id} className="border-b border-white/5 hover:bg-white/5">
                  <td className="p-4 text-white max-w-[150px] truncate">{review.product_name}</td>
                  <td className="p-4">
                    <p className="text-white">{review.user_name}</p>
                    <p className="text-[#71717a] text-xs">{review.user_email}</p>
                  </td>
                  <td className="p-4">
                    <span className="text-[#C0A062]">{"★".repeat(review.rating)}{"☆".repeat(5-review.rating)}</span>
                  </td>
                  <td className="p-4 max-w-[300px]">
                    <p className="text-white font-bold text-sm">{review.title}</p>
                    <p className="text-[#71717a] text-sm truncate">{review.comment}</p>
                  </td>
                  <td className="p-4">
                    {review.is_visible ? (
                      <span className="text-[#8CB369] text-sm flex items-center gap-1"><Eye className="w-4 h-4" />Yes</span>
                    ) : (
                      <span className="text-[#71717a] text-sm flex items-center gap-1"><EyeOff className="w-4 h-4" />Hidden</span>
                    )}
                  </td>
                  <td className="p-4 text-right">
                    <button onClick={function() { handleToggleVisibility(review.id, review.is_visible); }} className="p-2 text-[#A1A1AA] hover:text-[#C0A062]">
                      {review.is_visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                    </button>
                    <button onClick={function() { handleDelete(review.id); }} className="p-2 text-[#A1A1AA] hover:text-red-400">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              );
            })}
            {reviews.length === 0 && (
              <tr><td colSpan="6" className="p-8 text-center text-[#71717a]">No reviews yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
